import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"margin-bottom":"4px"},
  viewBox: "0 0 640 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M64.921 163.404c-35.872 0-64.894 29.228-64.894 65.355v217.85c0 36.126 29.022 65.355 64.894 65.355h389.364c35.872 0 64.894-29.229 64.894-65.355V330.422c0-12.072-9.644-21.785-21.631-21.785s-21.631 9.713-21.631 21.785V446.61c0 12.072-9.644 21.785-21.632 21.785H64.921c-11.987 0-21.631-9.713-21.631-21.785v-217.85c0-12.072 9.644-21.785 21.631-21.785h256.606c11.987 0 21.631-9.712 21.631-21.785 0-12.072-9.644-21.785-21.63-21.785z",
      style: {"color":"currentColor","fill":"currentColor","stroke-width":".264583"}
    }, null, -1),
    _createElementVNode("path", {
      d: "m579.593 73.715 10.726 10.802c8.472 8.533 8.472 22.33 0 30.771L571.3 134.532l-41.19-41.482 18.748-19.153c8.472-8.623 22.172-8.623 30.734-.09zm-188.643 161.3 108.787-111.013 41.01 41.301L431.238 275.68c-2.974 2.996-6.76 5.083-10.816 5.9l-44.704 9.44 9.373-45.113c.811-4.084 2.884-7.897 5.769-10.801zM518.124 43.217 360.125 204.425c-8.743 8.896-14.781 20.242-17.305 32.496l-16.224 77.79c-1.532 7.172.721 14.705 5.859 19.88 5.137 5.173 12.618 7.443 19.739 5.9l77.061-16.248c12.348-2.633 23.614-8.805 32.537-17.791L620.963 146.15c25.327-25.506 25.327-66.898 0-92.404l-10.816-10.802c-25.416-25.688-66.786-25.506-92.023.273z",
      style: {"color":"currentColor","fill":"currentColor","stroke-width":".264583"}
    }, null, -1)
  ]))]))
}
export default { render: render }